import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectTrustInfo = createSelector(selectLoanApplication, ({ trust }) => trust);
